'use client';

import {
	BigNum,
	SpotMarketConfig,
	SPOT_MARKET_BALANCE_PRECISION_EXP,
} from '@velocity-exchange/sdk';
import useAccountTargetSpotBalance from './useAccountTargetSpotBalance';

const useSubaccountCollateralBalanceForBank = (props: {
	accountKey?: string;
	market: SpotMarketConfig;
	useTokenBalance?: boolean;
}) => {
	const bankBalance = useAccountTargetSpotBalance(
		props.market,
		props.accountKey
	);

	if (!bankBalance.assetBaseBalance)
		return BigNum.zero(
			props.useTokenBalance
				? (bankBalance?.asset?.precisionExp ?? 0)
				: SPOT_MARKET_BALANCE_PRECISION_EXP
		);

	return bankBalance.assetBaseBalance;
};

export default useSubaccountCollateralBalanceForBank;
